import { ICellRendererParams } from 'ag-grid-community'
import { RadioGroup, Typography } from '@musinsa/layer-components-desktop'
import { ShipperMasterRow } from '@/services/master/userManagement/types'
import { RadioCellWrap } from './styles'

export function BooleanYNCellRenderer({ value }: ICellRendererParams) {
  return (
    <Typography name="base-text-l" colorToken={value ? 'fg' : 'fg-low'}>
      {value ? 'Y' : 'N'}
    </Typography>
  )
}

/** 1단(화주) 테이블 라디오 버튼 셀 렌더러 — 단일 선택(부서 추가 대상) */
export function OwnerRadioCellRenderer({ node, api }: ICellRendererParams<ShipperMasterRow>) {
  const isSelected = node.isSelected() ?? false
  const value = node.data?.shipperCode ?? String(node.rowIndex ?? 0)
  return (
    <RadioCellWrap>
      <RadioGroup.Root<string>
        value={isSelected ? value : '__none__'}
        onValueChange={() => {
          api.deselectAll()
          node.setSelected(true)
        }}
      >
        <RadioGroup.Item value={value} size="small" />
      </RadioGroup.Root>
    </RadioCellWrap>
  )
}
